if (process.env.NODE_ENV === 'production') {
    module.exports = require('config/store/configureStore.prod');
} else {
    module.exports = require('config/store/configureStore.dev');
}



// WEBPACK FOOTER //
// ./src/config/store/configureStore.js